export enum ChanelAudioContent {
  CTM = 'CTM',
  AGENT = 'AGENT',
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/tabs/ticket/detail_ticket.const.ts